import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { ProductsCompareLocationState } from '@components/products-compare-modal/Types';
import { Periodicity } from '@components/time-period-selector/PeriodsTypes';
import { ProductType } from '../product-analyzer/Product';
import { RelativePeriod } from '@components/comparison-period-selector/Types';
import { StorageKey, getLocalStorage, setLocalStorage } from '@utils/StorageUtils';

const useCompareProductsState = (): ProductsCompareLocationState => {
  const location = useLocation();
  const [compareModels, setCompareModels] = useState<ProductsCompareLocationState | undefined>(undefined);

  useEffect(() => {
    const { state } = location;
    const localData = getLocalStorage(StorageKey.CompareProductsData);

    // Handle the case when state is undefined but there is data in localStorage (in case of browser page reload)
    if (!state && localData) {
      setCompareModels(JSON.parse(localData) as ProductsCompareLocationState);
    } else if (state) {
      setCompareModels(state as ProductsCompareLocationState);
      setLocalStorage(StorageKey.CompareProductsData, JSON.stringify(state));
    }
  }, [location]);

  const defaultState: ProductsCompareLocationState = {
    timeFrame: Periodicity.Weekly,
    factRevenue: { currencySymbol: '', currencyLabel: '' },
    currentProductType: ProductType.PerformanceAnalyzer,
    relativePeriod: RelativePeriod.PreviousPeriod,
    selectedPeriod: { label: '', value: '', lastUpdatedDate: 0 },
    latestPeriod: { label: '', value: '', lastUpdatedDate: 0 },
    selectedModels: [],
  };

  return compareModels ?? defaultState;
};

export default useCompareProductsState;
